import { use } from 'react';
import PageContext from '../page.context';
const INITIAL_FORM_ERRORS = {
    isFormInError: false,
    setShowFormErrors: () => undefined,
    showFormErrors: false,
    loadingFormErrors: true
};
const usePageFormErrors = (formId) => {
    const { formErrors: allForms } = use(PageContext);
    return allForms[formId] ?? INITIAL_FORM_ERRORS;
};
export default usePageFormErrors;
